<!-- ════════════ NAVBAR ════════════ -->
<nav class="unav">
  <div class="container-fluid">
    <a class="unav-brand" routerLink="/">
      <img src="assetses/img/logo.png" alt="UMYOBizDFW">
      <span>UMYO<em>BizDFW</em></span>
    </a>
    <button class="unav-tog" id="navTog" (click)="toggleNav()"><span></span><span></span><span></span></button>
    <ul class="unav-links" id="navLinks" [class.nav-open]="isNavOpen">
      <li><a href="/" >Home</a></li>
      <li><a href="/about" class="active">About Us</a></li>
      <li><a routerLink="/networks">Network</a></li>
      <li><a routerLink="/hub">Hub</a></li>
      <li><a routerLink="/anti-bullying">Anti-Bullying</a></li>
      <li><a routerLink="/community-impact">Community Fund</a></li>
      <li><a routerLink="/empower-youth">Empower Youth</a></li>
      <li><a routerLink="/services">Type of Servcies</a></li>
      <li><a routerLink="/cf">Card Features</a></li>
    </ul>
    <!-- <a href="/#registration-form" class="unav-cta" >Join $2.54/mo</a> -->
  </div>
</nav>
  <!-- HERO -->
  <section class="hero">
    <div class="circuit-bg"></div>
    <div class="orb orb-1"></div>
    <div class="orb orb-2"></div>
    <div class="container" style="padding-top:90px; position:relative; z-index:1;">
      <div class="row align-items-center gy-5">
        <div class="col-lg-8">
          <p class="hero-eyebrow">About UMYOBizDFW</p>
          <h1 class="hero-title">
            Building a<br>
            Stronger<br>
            <span>Dallas–Fort Worth</span>
          </h1>
          <p class="hero-subtitle">From the inside out — a secure, structured digital ecosystem where DFW residents, businesses, and students grow together, not separately.</p>
          <div style="opacity:1; animation: fadeUp 0.8s ease 1.1s forwards;">
            <span class="hero-badge">We are not social media. We are community infrastructure.</span>
          </div>
        </div>
        <div class="col-lg-4 d-none d-lg-flex justify-content-center" style="opacity:0; animation:fadeIn 1.2s ease 1s forwards;">
          <div class="hero-circle-outer">
            <div class="hero-circle-inner">
              <img src="assetses/img/logo.png" alt="Logo" class="hero-logo-img"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hero-scroll-line">
      <div class="scroll-bar"></div>
      <span>Scroll</span>
    </div>
  </section>

  <!-- ══════════════════════════
       OUR WHY
  ══════════════════════════ -->
  <section class="why-section" id="why">
    <div class="container">
      <div class="row mb-5 gy-4">
        <div class="col-lg-6">
          <p class="section-label " sipScrollReveal [sipDelay]="0">Our Why</p>
          <h2 class="section-title " sipScrollReveal [sipDelay]="0.08">Dallas–Fort Worth<br>is <em>growing fast.</em></h2>
          <div class="cyan-divider " sipScrollReveal [sipDelay]="0.16"></div>
          <p class="" sipScrollReveal [sipDelay]="0.24" style="color:var(--text-muted); font-size:1.02rem; line-height:1.85; max-width:480px;">
            One of the fastest-growing regions in the country. But rapid growth without structure leads to deep fractures. We saw the need — and we built the solution.
          </p>
        </div>
        <div class="col-lg-6 d-flex align-items-center">
          <blockquote class="" sipScrollReveal [sipDelay]="0.32" style="font-family:'Playfair Display',serif; font-style:italic; font-size:1.2rem; color:var(--off-white); line-height:1.9; border-left:2px solid var(--cyan); padding-left:1.5rem; box-shadow:-4px 0 12px rgba(0,212,255,0.15); margin-top:1.5rem;">
            A privacy-gated platform designed exclusively for DFW — where trust, safety, and local reinvestment are the foundation, not afterthoughts.
          </blockquote>
        </div>
      </div>
      <div class="row g-4">
        <div class="col-sm-6 col-lg-4 " sipScrollReveal [sipDelay]="0"><div class="problem-card"><div class="problem-icon">👧</div><h5>Youth Vulnerability</h5><p>Young people exposed to exploitation and bullying with no structured community safety net.</p></div></div>
        <div class="col-sm-6 col-lg-4 " sipScrollReveal [sipDelay]="0.08"><div class="problem-card"><div class="problem-icon">🏘️</div><h5>Community Disconnection</h5><p>Neighbors drifting apart as digital platforms pull attention away from local ties.</p></div></div>
        <div class="col-sm-6 col-lg-4 " sipScrollReveal [sipDelay]="0.16"><div class="problem-card"><div class="problem-icon">💸</div><h5>Economic Leakage</h5><p>Local dollars flowing out of DFW neighborhoods into outside corporations and platforms.</p></div></div>
        <div class="col-sm-6 col-lg-4 " sipScrollReveal [sipDelay]="0.24"><div class="problem-card"><div class="problem-icon">🔒</div><h5>Digital Exploitation</h5><p>Residents unprotected from data harvesting, surveillance, and manipulative algorithms.</p></div></div>
        <div class="col-sm-6 col-lg-4 " sipScrollReveal [sipDelay]="0.32"><div class="problem-card"><div class="problem-icon">📢</div><h5>Rising Ad Costs</h5><p>Small local businesses priced out of effective advertising by big-tech platforms.</p></div></div>
        <div class="col-sm-6 col-lg-4 " sipScrollReveal [sipDelay]="0.4">
          <div class="problem-card" style="background:rgba(0,212,255,0.06); border-color:rgba(0,212,255,0.25); box-shadow:0 0 30px rgba(0,212,255,0.07);">
            <div class="problem-icon">🛡️</div><h5>UMYOBizDFW is the Answer</h5>
            <p>Real problems. Measurable solutions. Built for Dallas–Fort Worth by people who care.</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ══════════════════════════
       STUDENTS FIRST
  ══════════════════════════ -->
  <section class="students-section" id="students">
    <div class="container">
      <div class="row align-items-center g-5">
        <div class="col-lg-6">
          <p class="section-label " sipScrollReveal [sipDelay]="0">Our Foundation</p>
          <h2 class="section-title " sipScrollReveal [sipDelay]="0.08">Students<br><em>First</em></h2>
          <div class="cyan-divider " sipScrollReveal [sipDelay]="0.16"></div>
          <p class="" sipScrollReveal [sipDelay]="0.24" style="color:var(--text-muted); font-size:0.98rem; line-height:1.85; margin-bottom:2rem;">
            At the core of UMYOBizDFW is the <strong style="color:var(--off-white);">DFW Anti-Bullying Movement</strong> — sponsored by Dallas Security Academy and backed by professional MMA fighters, including UFC Fighter <strong style="color:var(--cyan); text-shadow:0 0 8px rgba(0,212,255,0.3);">Kennedy Nzechukwu</strong>.
          </p>
          <div class="fighter-badge mb-4" sipScrollReveal [sipDelay]="0.32" style="display: flex; align-items: center; gap: 1.2rem; padding: 1.2rem 1.5rem; transition-delay: 0.3s;">
            <div style="flex-shrink:0;width:100px;height:100px;border-radius:50%;border:2px solid rgba(0,212,255,.35);overflow:hidden;box-shadow:0 0 24px rgba(0,212,255,.25);background:#040d18;">
              <img src="assetses/img/Kennedy-Nzechukwu.png" alt="Kennedy Nzechukwu UFC Fighter" style="width:100%;height:100%;object-fit:cover;object-position:top;">
            </div>
            <div>
              <h4 style="margin:0 0 .3rem;">🥊 Kennedy Nzechukwu</h4>
              <p style="font-size:0.84rem; color:rgba(94,232,255,0.8); margin:0;">UFC Professional Fighter &amp; DFW Anti-Bullying Advocate</p>
              <p style="font-size:0.78rem; color:var(--text-muted); margin:.2rem 0 0;">100K+ Platform Reach · Dallas Security Academy Partner</p>
            </div>
          </div>
          <p class="" sipScrollReveal [sipDelay]="0.4" style="color:var(--text-muted); font-size:0.98rem; line-height:1.9;">
            We believe: <em style="color:var(--off-white);">No student should suffer in silence. No family should feel isolated. No young person should face adversity alone.</em>
          </p>
        </div>
        <div class="col-lg-6 " sipScrollReveal [sipDelay]="0.48">
          <p class="section-label mb-3">Through Verified School Partnerships, Students Access:</p>
          <div style="display:flex; flex-wrap:wrap; margin-bottom:2rem;">
            <span class="benefit-pill">💪 Strength &amp; Conditioning</span>
            <span class="benefit-pill">🥋 Self-Defense Instruction</span>
            <span class="benefit-pill">🧠 Life &amp; Behavioral Coaching</span>
            <span class="benefit-pill">⭐ Confidence Development</span>
            <span class="benefit-pill">🎯 Critical Thinking Skills</span>
            <span class="benefit-pill">👨‍👩‍👧 Parental Coaching Support</span>
            <span class="benefit-pill">🏋️ Discipline Training</span>
          </div>
          <div style="background:rgba(0,212,255,0.04); border:1px solid rgba(0,212,255,0.12); border-radius:12px; padding:2rem;">
            <p style="font-family:'Playfair Display',serif; font-style:italic; font-size:1.08rem; color:var(--off-white); line-height:1.85; margin:0;">
              "This is mentorship backed by professional fighters and certified trainers — structured, measurable, and available to qualified students across DFW."
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ══════════════════════════
       ECONOMIC MODEL
  ══════════════════════════ -->
  <section class="economy-section" id="economy">
    <div class="container">
      <div class="text-center mb-5">
        <p class="section-label " sipScrollReveal [sipDelay]="0">Our Economic Model</p>
        <h2 class="section-title " sipScrollReveal [sipDelay]="0.08">Structured<br><em>Reinvestment</em></h2>
        <div class="cyan-divider " sipScrollReveal [sipDelay]="0.16" style="margin:1.5rem auto;"></div>
        <p class="" sipScrollReveal [sipDelay]="0.24" style="color:var(--text-muted); font-size:1rem; max-width:480px; margin:0 auto;">
          This is not charity. This is transparent, structured reinvestment into our own region. Every local dollar circulates locally.
        </p>
      </div>
      <div class="row align-items-center g-5">
        <div class="col-lg-5 " sipScrollReveal [sipDelay]="0.32">
          <div class="revenue-ring-wrap mb-4">
            <div class="revenue-ring">
              <div class="revenue-ring-inner">
                <span>Revenue</span>
                <strong>Distribution</strong>
              </div>
            </div>
          </div>
          <div style="display:flex; justify-content:center; flex-wrap:wrap; gap:0.6rem; margin-top:1.2rem;">
            <span style="display:flex;align-items:center;gap:0.4rem;font-size:0.78rem;color:var(--text-muted);"><span style="width:10px;height:10px;border-radius:50%;background:var(--cyan);box-shadow:0 0 6px var(--cyan);display:inline-block;"></span>Anti-Bullying 20%</span>
            <span style="display:flex;align-items:center;gap:0.4rem;font-size:0.78rem;color:var(--text-muted);"><span style="width:10px;height:10px;border-radius:50%;background:#005fa8;display:inline-block;"></span>DSA Expansion 15%</span>
            <span style="display:flex;align-items:center;gap:0.4rem;font-size:0.78rem;color:var(--text-muted);"><span style="width:10px;height:10px;border-radius:50%;background:#0057ff;display:inline-block;"></span>Expansion Fund 15%</span>
            <span style="display:flex;align-items:center;gap:0.4rem;font-size:0.78rem;color:var(--text-muted);"><span style="width:10px;height:10px;border-radius:50%;background:#003a6e;display:inline-block;"></span>Operations 50%</span>
          </div>
        </div>
        <div class="col-lg-7 " sipScrollReveal [sipDelay]="0.4">
          <div class="revenue-item">
            <div class="revenue-dot" style="background:var(--cyan); box-shadow:0 0 8px var(--cyan);"></div>
            <div><h6>20% → Anti-Bullying Associations</h6><p>Direct funding to organizations fighting bullying across DFW.</p></div>
          </div>
          <div class="revenue-item">
            <div class="revenue-dot" style="background:#005fa8; box-shadow:0 0 8px #005fa8;"></div>
            <div><h6>15% → Dallas Security Academy</h6><p>Expansion of facilities, training programs, and certified staff.</p></div>
          </div>
          <div class="revenue-item">
            <div class="revenue-dot" style="background:#0057ff; box-shadow:0 0 8px #0057ff;"></div>
            <div><h6>15% → Members-Owned Expansion Fund</h6><p>Community-controlled capital for infrastructure and regional growth.</p></div>
          </div>
          <div style="margin-top:2rem;">
            <p class="section-label" style="margin-bottom:1rem;">Funds Are Used For:</p>
            <div>
              <span class="fund-tag">📚 Student Programs</span>
              <span class="fund-tag">🏢 Facility Expansion</span>
              <span class="fund-tag">🚌 Transportation</span>
              <span class="fund-tag">🏠 Mortgage &amp; Utility Assistance</span>
              <span class="fund-tag">⛽ Gas &amp; Food Support</span>
              <span class="fund-tag">🎁 Community Business Giveaways</span>
            </div>
          </div>
          <div style="margin-top:2rem; padding:1.2rem 1.5rem; background:rgba(0,212,255,0.05); border-left:2px solid var(--cyan); border-radius:0 8px 8px 0; box-shadow:-4px 0 12px rgba(0,212,255,0.1);">
            <p style="margin:0; color:var(--off-white); font-size:0.95rem;">When local dollars circulate locally, <strong style="color:var(--cyan);">entire neighborhoods strengthen.</strong></p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ══════════════════════════
       FOR BUSINESSES
  ══════════════════════════ -->
  <section class="biz-section" id="business">
    <div class="container">
      <div class="row g-5 align-items-start">
        <div class="col-lg-6">
          <p class="section-label " sipScrollReveal [sipDelay]="0">For Businesses</p>
          <h2 class="section-title " sipScrollReveal [sipDelay]="0.08">More Than<br><em>Advertising</em></h2>
          <div class="cyan-divider " sipScrollReveal [sipDelay]="0.16"></div>
          <p class="" sipScrollReveal [sipDelay]="0.24" style="color:var(--text-muted); font-size:0.98rem; line-height:1.85; margin-bottom:2rem;">
            Traditional advertising is expensive and disconnected from real community impact. UMYOBizDFW changes that equation entirely.
          </p>
          <div class="biz-feature " sipScrollReveal [sipDelay]="0.32"><div class="biz-feature-num">01</div><div><h6>Hyper-Local Targeting</h6><p>Reach DFW residents in your exact neighborhoods, not random national audiences.</p></div></div>
          <div class="biz-feature " sipScrollReveal [sipDelay]="0.4"><div class="biz-feature-num">02</div><div><h6>Youth Impact Branding</h6><p>Brand visibility tied directly to student programs and measurable community outcomes.</p></div></div>
          <div class="biz-feature " sipScrollReveal [sipDelay]="0.48"><div class="biz-feature-num">03</div><div><h6>Event &amp; Facility Exposure</h6><p>Presence at DFW community events, training facilities, and school partnerships.</p></div></div>
          <div class="biz-feature " sipScrollReveal [sipDelay]="0.56"><div class="biz-feature-num">04</div><div><h6>Structured Partnership Programs</h6><p>Organized, measurable sponsorship with transparent impact reporting.</p></div></div>
          <div class="biz-feature " sipScrollReveal [sipDelay]="0.64"><div class="biz-feature-num">05</div><div><h6>Digital Marketing Integration</h6><p>Full digital marketing stack within the DFW ecosystem platform.</p></div></div>
        </div>
        <div class="col-lg-6">
          <div class="biz-cta-card " sipScrollReveal [sipDelay]="0.08">
            <div style="font-size:3rem; margin-bottom:1rem;">🤝</div>
            <h4>Student Impact Partnership Program</h4>
            <p style="color:var(--text-muted); font-size:0.94rem; line-height:1.75; margin-bottom:1.5rem;">
              Through our Student Impact Partnership Program, businesses do more than advertise — they help change lives. Your brand becomes synonymous with building stronger youth in DFW.
            </p>
            <a href="/#partner" class="btn-cyan">Become a Youth Impact Partner</a>
          </div>
          <div style="background:rgba(0,212,255,0.03); border:1px solid rgba(0,212,255,0.08); border-radius:12px; padding:1.6rem; margin-top:1.5rem;" class="" sipScrollReveal [sipDelay]="0.24">
            <p class="section-label" style="margin-bottom:1.2rem;">Community Alignment Metrics</p>
            <div style="display:flex;flex-direction:column;gap:1rem;">
              <div>
                <div style="display:flex;justify-content:space-between;font-size:0.78rem;color:var(--text-muted);margin-bottom:6px;"><span>Brand Trust</span><span style="color:var(--cyan);">High</span></div>
                <div class="prog-bar"><div class="prog-fill" style="width:85%;"></div></div>
              </div>
              <div>
                <div style="display:flex;justify-content:space-between;font-size:0.78rem;color:var(--text-muted);margin-bottom:6px;"><span>Local Reach</span><span style="color:var(--cyan);">Exclusive</span></div>
                <div class="prog-bar"><div class="prog-fill" style="width:92%;"></div></div>
              </div>
              <div>
                <div style="display:flex;justify-content:space-between;font-size:0.78rem;color:var(--text-muted);margin-bottom:6px;"><span>Community Impact</span><span style="color:var(--cyan);">Measurable</span></div>
                <div class="prog-bar"><div class="prog-fill" style="width:78%;"></div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ══════════════════════════
       FOR RESIDENTS
  ══════════════════════════ -->
  <section class="residents-section" id="residents">
    <div class="container">
      <div class="row align-items-center g-5">
        <div class="col-lg-5 text-center text-lg-start " sipScrollReveal [sipDelay]="0">
          <p class="section-label">For Residents</p>
          <div class="price-display"><sup>$</sup>2.54<span style="font-size:1.4rem;color:var(--text-muted);">/mo</span></div>
          <p style="color:var(--text-muted); font-size:0.88rem; margin-top:0.4rem; letter-spacing:0.06em; text-transform:uppercase;">Membership starts at</p>
          <p style="color:var(--text-muted); font-size:0.98rem; margin-top:1.5rem; line-height:1.8;">Priced for accessibility. Structured for inclusion. Every DFW resident deserves a safe digital home.</p>
          <a href="/#registration-form" class="btn-cyan mt-3 d-inline-block">Join the Community</a>
        </div>
        <div class="col-lg-7 " sipScrollReveal [sipDelay]="0.08">
          <h2 class="section-title mb-4">Your Safe<br><em>Digital Home</em></h2>
          <div class="resident-benefit"><span>🔐</span><p><strong style="color:var(--off-white);">Privacy Protection</strong> — A gated platform built exclusively for DFW. No data harvesting.</p></div>
          <div class="resident-benefit"><span>🤲</span><p><strong style="color:var(--off-white);">Trusted Connections</strong> — Verified community members, real relationships, no anonymous toxicity.</p></div>
          <div class="resident-benefit"><span>🌅</span><p><strong style="color:var(--off-white);">Reduced Negativity</strong> — Structured environment designed to eliminate the chaos of mainstream social media.</p></div>
          <div class="resident-benefit"><span>💼</span><p><strong style="color:var(--off-white);">Local Opportunities</strong> — Jobs, events, businesses, and programs all from within DFW.</p></div>
          <div class="resident-benefit"><span>🏙️</span><p><strong style="color:var(--off-white);">Real Community Engagement</strong> — Participate in shaping your neighborhood, not just scrolling past it.</p></div>
        </div>
      </div>
    </div>
  </section>

  <!-- ══════════════════════════
       VISION
  ══════════════════════════ -->
  <section class="vision-section" id="vision">
    <div class="container position-relative" style="z-index:1;">
      <p class="section-label " sipScrollReveal [sipDelay]="0">Our Vision</p>
      <h2 class="section-title " sipScrollReveal [sipDelay]="0.08">One Protected<br><em>Ecosystem</em></h2>
      <div class="cyan-divider " sipScrollReveal [sipDelay]="0.16" style="margin:1.5rem auto;"></div>
      <p class="" sipScrollReveal [sipDelay]="0.24" style="color:var(--text-muted); font-size:1rem; max-width:460px; margin:0 auto 0.5rem;">
        To register every DFW resident, business, organization, school, and anti-bullying association under one unified, secure network.
      </p>
      <div class="vision-grid " sipScrollReveal [sipDelay]="0.32">
        <div class="vision-cell"><div class="icon">🏙️</div><h5>Every Resident</h5><p>All of Dallas–Fort Worth represented and protected</p></div>
        <div class="vision-cell"><div class="icon">💼</div><h5>Every Business</h5><p>Local commerce growing within the ecosystem</p></div>
        <div class="vision-cell"><div class="icon">🏫</div><h5>Every School</h5><p>Education and safety integrated into one network</p></div>
        <div class="vision-cell"><div class="icon">🤝</div><h5>Every Organization</h5><p>Nonprofits and associations working in unity</p></div>
        <div class="vision-cell"><div class="icon">🛡️</div><h5>Anti-Bullying Assoc.</h5><p>Structured partnerships fighting bullying together</p></div>
        <div class="vision-cell" style="background:rgba(0,212,255,0.05);"><div class="icon">⭐</div><h5>One Stronger DFW</h5><p>United. Protected. Invested in each other.</p></div>
      </div>
    </div>
  </section>

  <!-- ══════════════════════════
       BELIEF
  ══════════════════════════ -->
  <section class="belief-section">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8 text-center">
          <p class="section-label " sipScrollReveal [sipDelay]="0">Our Belief</p>
          <h2 class="section-title  mb-5" sipScrollReveal [sipDelay]="0.08">What We<br><em>Stand For</em></h2>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-7">
          <div class="belief-line" sipScrollReveal [sipDelay]="0" id="b1">
            <div class="cyan-dot"></div>
            <div><p class="belief-line-when">When Dallas protects its students,</p><p class="belief-line-then">Fort Worth protects its future.</p></div>
          </div>
          <div class="belief-line" sipScrollReveal [sipDelay]="0.08" id="b2" style="transition-delay:0.12s;">
            <div class="cyan-dot"></div>
            <div><p class="belief-line-when">When businesses reinvest locally,</p><p class="belief-line-then">Neighborhoods stabilize.</p></div>
          </div>
          <div class="belief-line" sipScrollReveal [sipDelay]="0.24" id="b3" style="transition-delay:0.24s;">
            <div class="cyan-dot"></div>
            <div><p class="belief-line-when">When communities unite,</p><p class="belief-line-then">Bullying loses power.</p></div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ══════════════════════════
       CTA / JOIN
  ══════════════════════════ -->
  <section class="cta-section" id="join">
    <div class="cta-glow"></div>
    <div class="container position-relative" style="z-index:1;">
      <p class="section-label " sipScrollReveal [sipDelay]="0">Join The Movement</p>
      <h2 class="" sipScrollReveal [sipDelay]="0.08">
        Be Part of<br>
        <span>Something Real</span>
      </h2>
      <p class="" sipScrollReveal [sipDelay]="0.16">
        UMYOBizDFW is not just a platform — it is a movement. Security-first, student-centered, community-powered digital infrastructure built specifically for Dallas–Fort Worth.
      </p>
      <div class="" sipScrollReveal [sipDelay]="0.24" style="display:flex; gap:1rem; justify-content:center; flex-wrap:wrap;">
        <a href="/#registration-form" class="btn-cyan" style="font-size:1rem; padding:1.1rem 2.5rem;">👉 Join Now at umyobizdfw.com</a>
        <a href="/#partner" class="btn-outline-cyan" style="font-size:1rem; padding:1.1rem 2.2rem;">Become a Youth Impact Partner</a>
      </div>
      <div class="" sipScrollReveal [sipDelay]="0.32" style="display:flex; gap:3rem; justify-content:center; margin-top:5rem; flex-wrap:wrap;">
        <div style="text-align:center;">
          <div style="font-family:'Bebas Neue',sans-serif; font-size:2.5rem; color:var(--cyan); text-shadow:0 0 20px rgba(0,212,255,0.4);">$2.54</div>
          <div style="font-size:0.72rem; letter-spacing:0.15em; color:var(--text-muted); text-transform:uppercase;">Monthly Membership</div>
        </div>
        <div style="width:1px; background:rgba(0,212,255,0.1);"></div>
        <div style="text-align:center;">
          <div style="font-family:'Bebas Neue',sans-serif; font-size:2.5rem; color:var(--cyan); text-shadow:0 0 20px rgba(0,212,255,0.4);">DFW</div>
          <div style="font-size:0.72rem; letter-spacing:0.15em; color:var(--text-muted); text-transform:uppercase;">Exclusive Region</div>
        </div>
        <div style="width:1px; background:rgba(0,212,255,0.1);"></div>
        <div style="text-align:center;">
          <div style="font-family:'Bebas Neue',sans-serif; font-size:2.5rem; color:var(--cyan); text-shadow:0 0 20px rgba(0,212,255,0.4);">1</div>
          <div style="font-size:0.72rem; letter-spacing:0.15em; color:var(--text-muted); text-transform:uppercase;">Unified Network</div>
        </div>
      </div>
    </div>
  </section>


<!-- ════════ FOOTER ════════ -->
<footer class="ufoot">
  <div class="container">
    <img src="assetses/img/logo.png" alt="UMYOBizDFW" onerror="this.style.display='none'">
    <div class="ufb">UMYOBizDFW</div>
    <p>DFW's First Privacy-Gated Digital Community</p>
    <div class="d-flex justify-content-center gap-4 flex-wrap">
      <a href="/">Home</a>
      <a href="/about">About Us</a>
      <a routerLink="/networks">Network</a>
      <a routerLink="/hub">Hub</a>
      <a routerLink="/anti-bullying">Anti-Bullying</a>
      <a routerLink="/community-impact">Community Fund</a>
      <a routerLink="/empower-youth">Empower Youth</a>
      <a routerLink="/services">Type of Servcies</a>
      <a routerLink="/cf">Card Features</a>
      <a href="/terms">Terms &amp; Conditions</a>
    </div>
    <p class="ufc2">© 2025 UMYOBizDFW · Built by the community, for the community</p>
  </div>
</footer>